<template>
  <div class="app-container-v2 process-content-container">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">订单信息</span>
      </div>
      <div class="title-right">
        <el-button v-if="editBtnShow && !isReadOnly" type="primary" class="button-v2" @click="handleEdit">编辑</el-button>
      </div>
    </div>

    <div class="order-info-container flex vertical pl24 pr24 overflow-y">
      <div class="order-info-box flex vertical mt40">
        <div class="flex acenter">
          <div class="title-block mr8"></div>
          <span class="font-16 fw-500 color-0">日期信息</span>
        </div>
        <div class="flex acenter mt16">
          <span class="font-14 color-6 hl28 mr94">工资月份：{{ $day(data.orderInfo.wageMonth).format('YYYY年M月') }}</span>
          <span v-if="data.orderInfo.payDate" class="font-14 color-6 hl28">发薪日期：{{ $day(data.orderInfo.payDate).format('YYYY年M月D日') }}</span>
        </div>
      </div>

      <div class="order-info-box flex vertical mt40">
        <div class="flex acenter">
          <div class="title-block mr8"></div>
          <span class="font-16 fw-500 color-0">备注信息</span>
        </div>
        <div v-if="data.orderInfo.remark" class="flex acenter mt16">
          <span class="font-14 color-6 h-auto lh28 text-wrap">{{ data.orderInfo.remark }}</span>
        </div>
      </div>

      <div class="order-info-box flex vertical mt40">
        <div class="flex acenter">
          <div class="title-block mr8"></div>
          <span class="font-16 fw-500 color-0">信息附件</span>
        </div>
        <div v-if="$isNotEmpty(data.orderInfo.fileList)" class="file-list-container flex vertical mt16">
          <div v-for="item in data.orderInfo.fileList" class="file-box flex acenter mb24 pointer">
            <img src="@/assets/img/v2/service-process/文件名.png" class="size14 mr8"/>
            <span class="font-14 color-6 hl22" @click="$open(item.filePath)">{{ item.fileName }}</span>
          </div>
        </div>
      </div>

      <div v-if="!editBtnShow || $isNotEmpty(data.orderInfo.addFileList)" class="order-info-box flex vertical mt40">
        <div class="flex jbetween acenter">
          <div class="flex acenter">
            <div class="title-block mr8"></div>
            <span class="font-16 fw-500 color-0">补充附件</span>
          </div>
          <el-button v-if="!editBtnShow && !isReadOnly" type="primary" plain class="button-v2" @click="showAddModal('附件')">+ 添加补充附件</el-button>
        </div>
        <div v-if="$isNotEmpty(data.orderInfo.addFileList)" class="file-list-container flex vertical mt16">
          <div v-for="item in data.orderInfo.addFileList" class="file-box flex acenter mb24 pointer">
            <img src="@/assets/img/v2/service-process/文件名.png" class="size14 mr8"/>
            <span class="font-14 color-6 hl22" @click="$open(item.filePath)">{{ item.fileName }}</span>
          </div>
        </div>
      </div>

      <div v-if="!editBtnShow || $isNotEmpty(data.orderInfo.addRemarkList)" class="order-info-box flex vertical mt40">
        <div class="flex jbetween acenter">
          <div class="flex acenter">
            <div class="title-block mr8"></div>
            <span class="font-16 fw-500 color-0">补充说明</span>
          </div>
          <el-button v-if="!editBtnShow && !isReadOnly" type="primary" plain class="button-v2" @click="showAddModal('说明')" :disabled="isReadOnly">+ 添加补充说明</el-button>
        </div>
        <div class="flex vertical mt16">
          <div v-for="item in data.orderInfo.addRemarkList" class="flex acenter mb16">
            <span class="font-14 color-3 mr24 h-auto lh20 text-wrap">{{ item.remark }}</span>
            <span class="font-14 color-9" style="flex: 0 0 145px;">{{ $formatDateTime(item.createTime) }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="modal-v2" title="编辑订单" :visible.sync="orderModalShow" :close-on-click-modal="false" width="700px" append-to-body v-dialog-drag>
      <div class="flex vertical">
        <el-form ref="form" class="form-v2 report-form" :model="form" :rules="formRules" label-width="100px" style="margin: 40px 0; padding: 0 30px;" size="small">
          <el-form-item class="fixed-height" label="工资月份：" prop="wageMonth">
            <div class="date-picker-v2 w100">
              <el-date-picker v-model="form.wageMonth" type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="请选择年月" prefix-icon="none" :clearable="false"></el-date-picker>
              <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
            </div>
          </el-form-item>
          <el-form-item class="fixed-height" label="发薪日期：" prop="payTime">
            <div class="date-picker-v2 w100">
              <el-date-picker v-model="form.payTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择日期" prefix-icon="none" :clearable="false"></el-date-picker>
              <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
            </div>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input type="textarea" class="textarea-v2" v-model="form.remark" placeholder="请输入备注" maxlength="2000" :rows="4" />
          </el-form-item>
          <el-form-item label="信息附件：">
            <air-upload-file :file-list="fileList" @change="handleUploadFile"></air-upload-file>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="orderModalShow = false">取消</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog class="modal-v2" :title="addModal.title" :visible.sync="addModal.show" :close-on-click-modal="false" width="700px" append-to-body>
      <div class="flex vertical">
        <el-form ref="addForm" class="form-v2 report-form" :model="addForm" :rules="addFormRules" label-width="100px" style="margin: 40px 0; padding: 0 30px;" size="small">
          <el-form-item v-if="addModal.type === '说明'" label="补充说明：" prop="remark">
            <el-input type="textarea" class="textarea-v2" v-model="addForm.remark" placeholder="请输入补充说明" maxlength="2000" :rows="4" />
          </el-form-item>
          <el-form-item v-else label="补充附件：" prop="fileList">
            <air-upload-file :file-list="addForm.fileList" @change="handleAddUploadFile"></air-upload-file>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="addModal.show = false">取消</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleAdd">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/order'
import { mapGetters } from 'vuex';
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editBtnShow: true,
      submitLoading: false,
      form: {},
      formRules: {
        wageMonth: [{ required: true, message: '请选择工资月份', trigger: 'change' }],
      },
      fileList: [],
      removeFileList: [],
      orderModalShow: false,
      addForm: {},
      addFormRules: {
        remark: [{ required: true, message: '请填写补充说明', trigger: 'blur' }],
        fileList: [{ required: true, message: '请上传补充附件', trigger: 'blur' }]
      },
      addModal: {
        show: false,
        title: '',
        type: ''
      }
    }
  },
  watch: {
  },
  created() {
    this.editBtnShow = this.data.operCode === '待接单' || this.data.operCode === '已退回'
  },
  methods: {
    reset() {
      let orderInfo = this.data.orderInfo
      this.form = {
        orderId: orderInfo.id,
        wageMonth: orderInfo.wageMonth,
        payTime: orderInfo.payDate,
        remark: orderInfo.remark,
        attrs: [],
        cusId: this.$userInfo.cusId
      }
      this.fileList = orderInfo.fileList || []
      this.removeFileList = []
    },
    handleUploadFile({ file, fileList, type }) {
      this.fileList = fileList
      // 如果是删除之前已上传并保存过的文件
      if (type === 'remove' && file.id) {
        this.removeFileList.push(file)
      }
    },
    handleEdit() {
      this.reset()
      this.$nextTick(() => {
        this.orderModalShow = true
      })
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.attrs = this.fileList.map(item => ({id: item.id, fileId: item.fileId}))
          if (this.$isNotEmpty(this.removeFileList)) {
            let removeFileList = this.removeFileList.map(item => ({id: item.id, 'delete': '10020001'}))
            this.form.attrs = this.form.attrs.concat(removeFileList)
          }
          this.updateOrder(this.form)
        }
      })
    },
    resetAdd() {
      this.addForm = {
        orderId: this.data.orderInfo.id,
        remark: undefined,
        attrs: [],
        fileList: []
      }
    },
    handleAddUploadFile({ fileList }) {
      this.addForm.fileList = fileList
      this.$refs.addForm.validate()
    },
    showAddModal(type) {
      this.resetAdd()
      this.addModal.type = type
      this.addModal.title = `添加补充${type}`
      this.$nextTick(() => {
        this.addModal.show = true
        this.$nextTick(() => {
          this.$refs.addForm.resetFields()
        })
      })
    },
    handleAdd() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.addModal.type === '附件') {
            this.addForm.attrs = this.addForm.fileList.map(item => ({fileId: item.fileId, isAdd: '10020001'}))
          }
          this.addForm.isAddRemark = '10020001'
          this.updateOrder(this.addForm)
        }
      })
    },
    updateOrder(form) {
      this.submitLoading = true
      api.updateorder(form).then(res => {
        if (res.data.code === 0) {
          this.orderModalShow = false
          this.addModal.show = false
          this.$msgSuccess('保存成功')
          this.$emit('refresh')
        }
      }).finally(() => this.submitLoading = false)
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'isReadOnly'])
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.order-info-container {
  .order-info-box:last-child {
    margin-bottom: 40px;
  }
}
.title-block {
  width: 4px;
  height: 14px;
  background: #0093AB;
  border-radius: 2px;
}
.file-list-container {
  background: #F8F9FA;
  border-radius: 4px;
  padding: 30px 20px;

  .file-box:last-child {
    margin-bottom: 0;
  }
}
</style>
